module.exports = __webpack_public_path__ + "static/media/ic_ubicacion.df7d7975.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_ubicacion.webp
// module id = 166
// module chunks = 1